// React && Redux
import React from "react";
import { withRouter } from "react-router";

// Material
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Fab from "@material-ui/core/Fab";
import Grid from "@material-ui/core/Grid";
import Icon from "@material-ui/core/Icon";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

// Third Party
import Select from "react-select";

// Internal
import BreadcrumbsWrapper from "../atoms/Breadcrumbs";
import Spacer from "../atoms/Spacer";
import {
  getCurrentDateTime,
  getCurrentSchoolYear,
  getIcon,
  getOptionObject,
  insertItem,
  compare,
  updateObjectInArray,
} from "../atoms/Util";

// Config
import { buildConfig } from "../../config/master";

// Images
// import logo from "../../assets/images/mptc-logo.svg";
import { render } from "react-dom";
// import studentLogo from '../../../public/images/mptc-student-logo.svg';

// class styling
const styles = (theme) => ({
  actionGridItem: {
    // padding: '0 !important',
    ...theme.flex,
    alignItems: "flex-end",
  },
  actionWrapper: theme.flex,
  appBar: {
    backgroundColor: "#f0f0f0 !important",
    borderBottom: "3px solid #5bb84d",
  },
  backgroundAltActive: theme.backgroundAltActive,
  clearButton: {
    // marginLeft: 36,
  },
  // defaultText: theme.defaultText,
  fab: {
    marginLeft: 36,
    "&:hover": {
      backgroundColor: "#83db76",
    },
  },
  fabDisabled: {
    backgroundColor: "#aaaaaa",
    cursor: "default",
    marginLeft: 36,
    "&:hover": {
      backgroundColor: "#cccccc",
    },
  },
  flex: theme.flex,
  flexCenter: {
    ...theme.flex,
    alignItems: "center",
  },
  flexRight: {
    ...theme.flex,
    alignItems: "right",
  },
  // foregroundAltHover: theme.foregroundAltHover,
  gridItem: {
    paddingTop: "0 !important",
  },
  logo: {
    ...theme.appLogo,
    marginRight: 36,
  },
  marginLeftFilter: theme.marginLeftMd,
  marginRightMd: theme.marginRightMd,
  pointer: theme.pointer,
  select: {
    ...theme.select,
  },
  selectDisabled: {},
  selectWrapper: theme.flexGrow,
  wrapper: {
    backgroundColor: "#005776",
    color: "#f0f0f0",
    // display: 'flex',
    margin: "0 auto",
    minWidth: 360,
    padding: 24,
    width: "100%",
  },
});

class SearchFilter extends React.Component {
  constructor(props) {
    super(props);
    const { schoolYears } = props.options;
    const currentSchoolYear = getCurrentSchoolYear(schoolYears);

    const activeBackgroundColor = "rgba(91,184,77,0.3)"; // #5bb84d
    const defaultColor = "rgba(0, 0, 0, 0.87) !important"; // #000000
    const defaultPlaceholderColor = "rgb(89, 89, 89)"; // #oob color for react-select
    const disabledBackgroundColor = "rgb(170,170,170)"; // #aaa
    // const disabledBackgroundColorHover = 'rgba(170,170,170,0.7)'; // #aaa
    const disabledColor = "rgba(0, 0, 0, 0.9) !important"; // #000000
    const focusedBackgroundColor = "rgba(91,184,77,0.4)"; // #5bb84d
    const selectedBackgroundColor = "rgb(91,184,77)"; // #5bb84d

    const selectStyles = {
      control: (styles, { isDisabled }) => {
        return {
          ...styles,
          backgroundColor: isDisabled ? disabledBackgroundColor : "white",
          color: isDisabled ? disabledColor : defaultColor,
        };
      },
      option: (styles, { isDisabled, isFocused, isSelected }) => {
        return {
          ...styles,
          backgroundColor: isDisabled
            ? null
            : isSelected
              ? selectedBackgroundColor
              : isFocused
                ? focusedBackgroundColor
                : null,
          color: isDisabled ? disabledColor : defaultColor,
          cursor: isDisabled ? "not-allowed" : "default",
          ":active": {
            ...styles[":active"],
            backgroundColor:
              !isDisabled &&
              (isSelected ? defaultColor : activeBackgroundColor),
          },
        };
      },
      multiValueLabel: (styles) => ({
        ...styles,
        color: defaultColor,
        backgroundColor: focusedBackgroundColor,
        borderRadius: "2px 0 0 2px",
      }),
      multiValueRemove: (styles) => ({
        ...styles,
        color: defaultColor,
        backgroundColor: focusedBackgroundColor,
        borderRadius: "0 2px 2px 0",
      }),
      placeholder: (styles, { isDisabled }) => {
        return {
          ...styles,
          color: isDisabled ? disabledColor : defaultPlaceholderColor,
        };
      },
    };
    this.state = {
      schoolYear: [getOptionObject(currentSchoolYear, currentSchoolYear)],
      selectStyles,
    };
  }

  handleFilterClear = (filterName) => {
    let options = {};
    if (filterName) {
      options = {
        [filterName]: null,
      };
      switch (filterName) {
        case "room":
          options.lab = null;
          options.deviceType = null;
          break;
        case "lab":
          options.deviceType = null;
          break;
      }
    } else {
      options.campus = null;
      options.room = null;
      options.lab = null;
      options.deviceType = null;
    }
    this.setState({ ...options });
  };

  handleFilterChange = (name, optionName, option) => {
    const { onFilterChange } = this.props;
    onFilterChange(name, optionName, option);
    if (!option || !option.length) {
      this.handleFilterClear(name);
    } else {
      this.setState({ [name]: option });
    }
  };

  handlePrintLabs = () => {
    const { activeFilters = [], assignments } = this.props;
    const subpath = buildConfig.subpath || "";

    const defaultSchoolFilter = {
      name: "schoolYear",
      optionName: "schoolYear",
      option: this.state.schoolYear ?? [],
    };

    // Extract the specific filter selections out of the parent's verified state array
    const schoolYearFilter =
      activeFilters.find((f) => f.name === "schoolYear") ?? defaultSchoolFilter;
    const campusFilter = activeFilters.find((f) => f.name === "campus");
    const roomFilter = activeFilters.find((f) => f.name === "room");
    const labFilter = activeFilters.find((f) => f.name === "lab");

    console.log("active filters", activeFilters);

    // Guard clause: Ensure our required fields are present in the parent state
    if (schoolYearFilter && campusFilter && roomFilter) {
      // Pull options array safely
      const selectedYear = schoolYearFilter.option.map((o) => o.value);
      const selectedCampus = campusFilter.option.map((o) => o.value);
      const selectedRooms = roomFilter.option.map((o) => o.value);
      const selectedLabs = labFilter?.option
        ? labFilter.option.map((o) => o.value)
        : [];

      const printedAssignments = assignments.filter((a) => {
        const matchesYear = selectedYear.includes(a.schoolYear);
        const matchesCampus = selectedCampus.includes(a.campus);
        const matchesRoom = selectedRooms.includes(a.room);
        // If no lab filter is active, default to true, otherwise check if it matches
        const matchesLab =
          selectedLabs.length === 0 || selectedLabs.includes(a.lab);

        return matchesYear && matchesCampus && matchesRoom && matchesLab;
      });

      const finalRoomParam = roomFilter.option.map((o) => o.value).join("&");
      const finalLabParam =
        selectedLabs.length > 0 ? selectedLabs.join("&") : "all";

      this.props.history.push(
        `${subpath}/lab/${finalRoomParam}/${finalLabParam}`,
        { assignments: printedAssignments || [] },
      );
    }
  };

  render() {
    const {
      classes,
      noSoftware = 0,
      onDialogClick,
      options = [],
      activeFilters = [],
    } = this.props;
    const {
      campuses = [],
      deviceTypes = [],
      labs = [],
      rooms = [],
      schoolYears = [],
      softwares = [],
    } = options;
    const { selectStyles } = this.state;

    // Extract the active, synchronized values straight from the parent state props
    const currentYearFilter = activeFilters.find(
      (f) => f.name === "schoolYear",
    );
    const currentCampusFilter = activeFilters.find((f) => f.name === "campus");
    const currentRoomFilter = activeFilters.find((f) => f.name === "room");
    const currentLabFilter = activeFilters.find((f) => f.name === "lab");
    const currentDeviceFilter = activeFilters.find(
      (f) => f.name === "deviceType",
    );

    // Format safe values to pass downstream to react-select blocks
    const yearValue = currentYearFilter
      ? currentYearFilter.option
      : this.state.schoolYear;
    const campusValue = currentCampusFilter ? currentCampusFilter.option : null;
    const roomValue = currentRoomFilter ? currentRoomFilter.option : null;
    const labValue = currentLabFilter ? currentLabFilter.option : null;
    const deviceValue = currentDeviceFilter ? currentDeviceFilter.option : null;

    return (
      <section className={classes.wrapper}>
        <Grid container className={classes.selectWrapper} spacing={3}>
          <Grid className={classes.gridItem} item xs={12} sm={4} lg={2}>
            <div className={classes.select}>
              <Typography
                className={classes.subtext}
                variant="caption"
                gutterBottom={true}
              >
                School Year
              </Typography>
              <Select
                aria-label="School Year"
                className={classes.select}
                isDisabled={false}
                isMulti={false}
                value={yearValue}
                onChange={(e) =>
                  this.handleFilterChange(
                    "schoolYear",
                    "schoolYear",
                    e ? [e] : null,
                  )
                }
                options={schoolYears}
                styles={selectStyles}
              />
            </div>
          </Grid>
          <Grid className={classes.gridItem} item xs={12} sm={4} lg={2}>
            <div className={classes.select}>
              <Typography
                className={classes.subtext}
                variant="caption"
                gutterBottom={true}
              >
                Campus
              </Typography>
              <Select
                aria-label="Campus"
                className={classes.select}
                isDisabled={!yearValue}
                isMulti={false}
                value={campusValue}
                onChange={(e) =>
                  this.handleFilterChange("campus", "room", e ? [e] : null)
                }
                options={campuses}
                styles={selectStyles}
              />
            </div>
          </Grid>
          <Grid className={classes.gridItem} item xs={12} sm={4} lg={2}>
            <div className={classes.select}>
              <Typography
                className={classes.subtext}
                variant="caption"
                gutterBottom={true}
              >
                Room
              </Typography>
              <Select
                aria-label="Room"
                className={classes.select}
                isDisabled={!campusValue}
                isMulti={true}
                value={roomValue}
                onChange={(e) => this.handleFilterChange("room", "lab", e)}
                placeholder={
                  campusValue ? `Select...` : `Select Campus to Enable...`
                }
                options={rooms}
                styles={selectStyles}
              />
            </div>
          </Grid>
          <Grid className={classes.gridItem} item xs={12} sm={6} lg={3}>
            <div className={classes.select}>
              <Typography
                className={classes.subtext}
                variant="caption"
                gutterBottom={true}
              >
                Lab
              </Typography>
              <Select
                aria-label="Lab"
                className={classes.select}
                isDisabled={!roomValue || roomValue.length === 0}
                isMulti={true}
                placeholder={
                  roomValue && roomValue.length > 0
                    ? `Select...`
                    : `Select Room to Enable...`
                }
                value={labValue}
                onChange={(e) =>
                  this.handleFilterChange("lab", "deviceType", e)
                }
                options={labs}
                styles={selectStyles}
              />
            </div>
          </Grid>
          <Grid className={classes.gridItem} item xs={12} sm={6} lg={3}>
            <div className={classes.select}>
              <Typography
                className={classes.subtext}
                variant="caption"
                gutterBottom={true}
              >
                Device Type
              </Typography>
              <Select
                aria-label="Device Type"
                className={classes.select}
                isDisabled={!labValue || labValue.length === 0}
                isMulti={true}
                placeholder={
                  labValue && labValue.length > 0
                    ? `Select...`
                    : `Select Lab to Enable...`
                }
                value={deviceValue}
                onChange={(e) =>
                  this.handleFilterChange("deviceType", "deviceType", e)
                }
                options={deviceTypes}
                styles={selectStyles}
              />
            </div>
          </Grid>
        </Grid>
        <BreadcrumbsWrapper
          separator=">"
          aria="filter breadcrumb"
          filters={[yearValue, campusValue, roomValue, labValue, deviceValue]}
          variant="caption"
        />
        <Grid
          container
          className={classes.actionWrapper}
          spacing={3}
          alignContent="center"
          alignItems="center"
        >
          <Grid
            className={classes.actionWrapper}
            item
            xs={12}
            sm={6}
            md={4}
            lg={2}
          >
            <Typography variant="caption" className={classes.flexCenter}>
              No. Softwares: {noSoftware}
            </Typography>
          </Grid>
          <Grid
            className={classes.actionGridItem}
            item
            xs={12}
            sm={6}
            md={4}
            lg={7}
          >
            <Spacer />
            <Tooltip title="view standard software installed in every lab">
              <Button
                color="inherit"
                size="small"
                aria-label="view standard software list"
                className={classes.button}
                onClick={onDialogClick}
              >
                <Icon>view_list</Icon>View Standard Software
              </Button>
            </Tooltip>
          </Grid>
          <Grid
            className={classes.actionGridItem}
            item
            xs={12}
            sm={12}
            md={4}
            lg={3}
          >
            <Spacer />
            <Tooltip title="clear selected filters">
              <Button
                color="inherit"
                aria-label="clear filter"
                className={classes.clearButton}
                onClick={() => this.handleFilterChange()}
              >
                Clear
              </Button>
            </Tooltip>
            <Tooltip
              title={
                yearValue && campusValue && roomValue
                  ? "print a list of all of the labs matching the filter"
                  : "select a school year, campus, and room to enable"
              }
            >
              <Fab
                color="secondary"
                variant="extended"
                aria-label="print labs"
                size="medium"
                className={
                  yearValue && campusValue && roomValue
                    ? classes.fab
                    : classes.fabDisabled
                }
                onClick={() => this.handlePrintLabs()}
              >
                <Icon>
                  {yearValue && campusValue && roomValue
                    ? "print"
                    : "print_disabled"}
                </Icon>
                Print Labs
              </Fab>
            </Tooltip>
          </Grid>
        </Grid>
      </section>
    );
  }
}

export default withStyles(styles)(withRouter(SearchFilter));
